import { Github } from 'lucide-react'
import { PREVIEW_APP_URL, GITHUB_REPO_URL } from '@/lib/constants'

export function FinalCTA() {
  return (
    <section className="bg-gray-50 py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        <div className="flex flex-col items-center text-center">
          <h2 className="mb-6 max-w-3xl font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl lg:text-5xl">
            Build consistent Flutter UI. With your team — and with AI.
          </h2>

          {/* Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={PREVIEW_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-xl bg-[#448AFF] px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-[#448AFF]/90 hover:shadow-lg hover:shadow-[#448AFF]/25"
            >
              View Components
            </a>
            <a
              href={GITHUB_REPO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-6 py-3 text-sm font-semibold text-gray-900 transition-all hover:border-gray-300 hover:bg-gray-50 dark:border-white/20 dark:bg-white/5 dark:text-white dark:hover:border-white/30 dark:hover:bg-white/10"
            >
              <Github className="h-4 w-4" />
              GitHub
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
